<template>
  <modal id="operatorsForm"
         v-model="visible"
         :title="$t('gc-backhaulGsmOperatorsForm:updateOperator')"
         :callback="updateOperator"
         @modal:cancel="cancel"
  >
    <small slot="modal-header-right" class="text-muted font-italic">{{ $t('gc-backhaulGsmOperatorsForm:required') | capitalize }}</small>

    <template #modal-body>
      <div class="form-group">
        <label for="operatorMcc" class="control-label">{{ $t('gc-backhaulGsmOperatorsForm:operatorMcc') | capitalize }} *</label>
        <input id="operatorMcc"
               v-model="operatorMcc"
               v-validate="'required|operatorCode:mcc'"
               :class="{ 'is-invalid': errors.has('operatorMcc') }"
               :data-vv-as="$t('gc-backhaulGsmOperatorsForm:operatorMcc')"
               type="text"
               name="operatorMcc"
               class="form-control"
        >
        <div class="invalid-feedback">{{ errors.first('operatorMcc') }}</div>
      </div>
      <div class="form-group">
        <label for="operatorMnc" class="control-label">{{ $t('gc-backhaulGsmOperatorsForm:operatorMnc') | capitalize }} *</label>
        <input id="operatorMnc"
               v-model="operatorMnc"
               v-validate="'required|operatorCode:mnc'"
               :class="{ 'is-invalid': errors.has('operatorMnc') }"
               :data-vv-as="$t('gc-backhaulGsmOperatorsForm:operatorMnc')"
               type="text"
               name="operatorMnc"
               class="form-control"
        >
        <div class="invalid-feedback">{{ errors.first('operatorMnc') }}</div>
      </div>

      <div class="form-group">
        <label for="operatorApn" class="control-label">{{ $t('gc-backhaulGsmOperatorsForm:operatorApn') | capitalize }}</label>
        <input id="operatorApn"
               key="operatorApn"
               v-model="operatorApn"
               v-validate="'text'"
               :data-vv-as="$t('a-customersForm:operatorApn')"
               :class="{ 'is-invalid': errors.has('operatorApn') }"
               name="operatorApn"
               type="text"
               class="form-control"
        >
        <div class="invalid-feedback">{{ errors.first('operatorApn') }}</div>
      </div>

      <div class="form-group">
        <label for="operatorLogin" class="control-label">{{ $t('gc-backhaulGsmOperatorsForm:operatorLogin') | capitalize }}</label>
        <input id="operatorLogin"
               key="operatorLogin"
               v-model="operatorLogin"
               v-validate="'text'"
               :data-vv-as="$t('a-customersForm:operatorLogin')"
               :class="{ 'is-invalid': errors.has('operatorLogin') }"
               name="operatorLogin"
               type="text"
               class="form-control"
        >
        <div class="invalid-feedback">{{ errors.first('operatorLogin') }}</div>
      </div>

      <div class="form-group">
        <label for="operatorPassword" class="control-label">{{ $t('gc-backhaulGsmOperatorsForm:operatorPassword') | capitalize }}</label>
        <input id="operatorPassword"
               key="operatorPassword"
               v-model="operatorPassword"
               :data-vv-as="$t('a-customersForm:operatorPassword')"
               name="operatorPassword"
               type="password"
               class="form-control"
        >
      </div>
    </template>
  </modal>
</template>

<script>
export default {
  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    // Display or hide modal
    // To be used as v-model
    show: {
      type: Boolean,
      required: true
    },

    operatorToEdit: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      // Display or hide b-modal
      // It cannot change our props, so we need another variable
      visible: false,
      // Form
      operatorApn: '',
      operatorLogin: '',
      operatorPassword: '',
      operatorMcc: '',
      operatorMnc: ''
    }
  },

  watch: {
    // Synchronize show and visible
    // Use change event to update v-model
    show () {
      this.reset()
      this.visible = this.show
    },
    visible () {
      this.$emit('change', this.visible)
    },

    operatorToEdit () {
      if (this.operatorToEdit) {
        this.operatorApn = this.operatorToEdit.operatorApn
        this.operatorLogin = this.operatorToEdit.operatorLogin
        this.operatorPassword = this.operatorToEdit.operatorPassword
        this.operatorMcc = this.operatorToEdit.operatorMcc
        this.operatorMnc = this.operatorToEdit.operatorMnc
      }
    }
  },

  methods: {
    async reset () {
      this.operatorApn = ''
      this.operatorLogin = ''
      this.operatorPassword = ''
      this.operatorMcc = ''
      this.operatorMnc = ''

      // Reset form validation
      await this.$nextTick()
      this.$validator.reset()
    },

    cancel () {
      this.visible = false
      this.$emit('cancel')
    },

    async updateOperator () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      const operator = {
        operatorApn: this.operatorApn,
        operatorLogin: this.operatorLogin,
        operatorPassword: this.operatorPassword,
        operatorMcc: this.operatorMcc,
        operatorMnc: this.operatorMnc
      }

      this.visible = false
      // Update operator in list
      this.$emit('update-operator', operator)
      // Reset form
      this.reset()
    }
  }
}
</script>
